export default {"src":"/_next/static/media/x.ede6607b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};